angular
  .module('jrLocationInput', ['jrConfig', 'jrTracking'])
  .controller('LocationAutocompleteCtrl', [
    'SearchFormService',
    'NavigationService',
    '$scope',
    '$http',
    function (SearchFormService, NavigationService, $scope, $http) {
      $scope.typeaheadFirstItem = '';

      $scope.typeaheadOnSelect = function (location) {
        $scope.typeaheadFirstItem = '';

        if (!SearchFormService.search.what || !location) {
          return;
        }

        NavigationService.toSearch({
          what: SearchFormService.search.what,
          where: location,
        });
      };

      $scope.getLocation = function (val, size) {
        return $http
          .post('/public/api/location/autocomplete', {
            prefix: val.toLowerCase(),
            size,
          })
          .then(function (response) {
            if (response.data.length > 0) {
              $scope.typeaheadFirstItem = response.data[0].canonicalName;
            } else {
              $scope.typeaheadFirstItem = '';
            }

            return response.data.map(function (item) {
              return item.canonicalName;
            });
          });
      };
    },
  ]);
